















































































































































































































































































































































































































import mixins from 'vue-typed-mixins'
import DraftActions from '@/builder/mixins/DraftActions'
import CalendeskImageSelectV2 from '@/components/Tools/CalendeskImageSelectV2.vue'
import { mapActions, mapGetters } from 'vuex'
import SectionImage from '@/calendesk/models/DTO/Response/SectionImage'
import SidebarDetails from '@/calendesk/models/SidebarDetails'
import { SidebarDetailsType } from '../sidebarDetails/SidebarDetailsType'
import { DraftActionsType } from '@/calendesk/models/DraftActionsType'
import GalleryInputV2 from '@/components/Tools/GalleryInputV2.vue'
import CItemsGallery from '@/components/Tools/CItemsGallery.vue'
import { DraftConfigurationType, DynamicFormType, SectionsSectionType } from '@/calendesk/models/BuilderTypes'
import { classToPlain, plainToClass } from 'class-transformer'
import CtaButtonData from '@/calendesk/models/CtaButtonData'
import CtaButtons from '@/components/Tools/CtaButtons/CtaButtons.vue'
import SectionFeatures from '@/components/Tools/SectionFeatures/SectionFeatures.vue'
import SectionsFeatureData from '@/calendesk/models/SectionsFeatureData'
import { SectionImageType } from '@/calendesk/models/DTO/Response/SectionImageType'
import SelectedGalleryImage from '@/calendesk/models/SelectedGalleryImage'
import { SectionImagePayload } from '@/calendesk/models/SectionImagePayload'
import CItemsGalleryActions from '@/builder/mixins/CItemsGalleryActions'
import CalendeskInformationMessage from '@/lib/calendesk-js-library/components/CalendeskInformationMessage.vue'
import PagesSingleSelect from '@/builder/sidebar/sidebarDetails/components/PageSingleSelect.vue'
import CtaButton from '@/components/Tools/CtaButtons/components/CtaButton.vue'
import TipTap from '@/lib/calendesk-js-library/components/TipTap.vue'
import { BuilderSelectType } from '@/calendesk/models/BuilderSelectType'
import DefaultButtonsPositions from '@/calendesk/models/DefaultButtonsPositions'
import DefaultImagePositions from '@/calendesk/models/DefaultImagePositions'
import { AlignType } from '@/calendesk/models/AlignType'
import SimpleStoreActions from '@/builder/mixins/SimpleStoreActions'
import { RoundType } from '@/calendesk/models/RoundType'
import DefaultRoundTypes from '@/calendesk/models/DefaultRoundTypes'
import DefaultSelectionOrders from '@/calendesk/models/DefaultSelectionOrders'
import { SelectionOrderType } from '@/calendesk/models/SelectionOrderType'
import { GalleryStyleType } from '@/calendesk/models/GalleryStyleType'
import DefaultGalleryStyles from '@/calendesk/models/DefaultGalleryStyles'
import { DraftConfiguration } from '@/calendesk/models/DraftConfiguration'
import DefaultButtonSizeTypes from '@/calendesk/models/DefaultButtonSizeTypes'
import { ButtonSizeType } from '@/calendesk/models/ButtonSizeType'
import CTimePicker from '@/components/Tools/CTimePicker.vue'
import DynamicForm from '@/components/Tools/DynamicForm/DynamicForm.vue'
import DynamicFormData from '@/calendesk/models/DynamicFormData'
import Page from '@/calendesk/models/DTO/Response/Page'
import GdprFieldData from '@/calendesk/models/GdprFieldData'
import GdprFields from '@/components/Tools/GdprFields/GdprFields.vue'
import DefaultFormPositions from '@/calendesk/models/DefaultFormPositions'
import CalendarInput from '@/lib/calendesk-js-library/components/CalendarInput.vue'
import StaticPage from '@/calendesk/models/StaticPage'
import SettingTooltip from '@/components/Tools/SettingTooltip.vue'
import {
  SECTION_GROUP_ORDER,
  SECTION_GROUP_TITLES,
  sectionSettingGroupForKey
} from '@/builder/sidebar/sectionSettingGroups'
import { panelsToOpen, rememberOpenPanels } from '@/builder/sidebar/settingGroupState'
import { MIN_SETTINGS_FOR_FILTER, matchesSettingFilter } from '@/builder/sidebar/settingFilter'

// A "require" checkbox is dead while its "show" checkbox is off - the client
// site never validates a field it does not render. Checking "require" turns
// "show" on; unchecking "show" turns "require" off.
const REQUIRE_TO_SHOW: Record<string, string> = {
  wb_require_phone_number__checkbox__: 'wb_show_phone_number__checkbox__',
  wb_require_billing_data__checkbox__: 'wb_show_billing_data__checkbox__'
}

// The availability window pickers constrain each other so "to" can never be
// set before "from".
const DATE_RANGE_PAIRS: Array<{ from: string; to: string }> = [
  { from: 'wb_calendar_min_date__date__', to: 'wb_calendar_max_date__date__' }
]

export default mixins(DraftActions, CItemsGalleryActions, SimpleStoreActions).extend({
  name: 'Tools',
  components: {
    SettingTooltip,
    CalendarInput,
    GdprFields,
    DynamicForm,
    CTimePicker,
    TipTap,
    CtaButton,
    PagesSingleSelect,
    CalendeskInformationMessage,
    SectionFeatures,
    CtaButtons,
    CalendeskImageSelectV2,
    GalleryInputV2,
    CItemsGallery
  },
  data () {
    return {
      draftConfigurationType: DraftConfigurationType,
      sectionsSectionType: SectionsSectionType,
      tools: [
        DraftConfigurationType.DYNAMIC_FORM,
        DraftConfigurationType.TEXT,
        DraftConfigurationType.SECTION_FEATURES,
        DraftConfigurationType.LONG_TEXT,
        DraftConfigurationType.HTML_TEXT,
        DraftConfigurationType.GDPR_FIELDS,
        DraftConfigurationType.NUMBER,
        DraftConfigurationType.DATE,
        DraftConfigurationType.STYLE_HEIGHT,
        DraftConfigurationType.SELECT,
        DraftConfigurationType.CTA_BUTTON,
        DraftConfigurationType.ARRAY_CTA_BUTTONS,
        DraftConfigurationType.PAGE_IDS,
        DraftConfigurationType.PAGE_ID,
        DraftConfigurationType.EMPLOYEES,
        DraftConfigurationType.SERVICES,
        DraftConfigurationType.EXTERNAL_CONFIGURATION,
        DraftConfigurationType.ALERT,
        DraftConfigurationType.CHECKBOX,
        DraftConfigurationType.URL,
        DraftConfigurationType.TIME
      ] as Array<DraftConfigurationType>,
      mode: DraftActionsType.SECTION,
      imageTypes: SectionImageType,
      loading: false,
      settingsFilter: '',
      openPanels: Array<number>()
    }
  },
  watch: {
    // Every save clones the draft and replaces selectedSection with a new
    // object (refreshConfiguration then rebuilds the whole configuration
    // array), so watching either of those would collapse the open panel
    // while the user is typing. The uuid only changes when the user picks
    // a different section — the one moment the panels should reset.
    'selectedSection.uuid' () {
      this.settingsFilter = ''
      this.resetOpenPanels()
    },
    settingsFilter (query: string) {
      // A search that leaves its hits collapsed inside group headers answers
      // nothing, so every group with a match opens while filtering.
      this.openPanels = panelsToOpen(this.groupIds, { filtering: !!query })
    },
    openPanels (indexes: Array<number>) {
      // Panels opened by the filter or forced open as the only group are a
      // side effect, not a choice the user made.
      if (!this.settingsFilter && !this.hasSoleGroup) {
        rememberOpenPanels(this.groupIds, indexes)
      }
    }
  },
  mounted () {
    this.resetOpenPanels()

    const toLoad = []

    if (!this.employees) {
      toLoad.push(this.fetchEmployees())
    }

    if (!this.products) {
      toLoad.push(this.fetchProducts())
    }

    if (toLoad.length > 0) {
      Promise.all(toLoad)
    }
  },
  computed: {
    ...mapGetters({
      draftPages: 'builder/getDraftPages',
      getSidebar: 'sidebar/getSidebar'
    }),
    baseColors (): boolean {
      const invertCheckbox = this.configuration.find((config) => config.key === 'wb_invert_colors__checkbox__')

      if (invertCheckbox) {
        return !invertCheckbox.value
      }

      return true
    },
    draftPagesWithStaticPages (): (Page | StaticPage)[] {
      const staticPages = StaticPage.getAllStaticPages()

      return [...this.draftPages, ...staticPages]
    },
    groupedConfiguration (): Array<{ id: string; titleKey: string; configs: Array<DraftConfiguration> }> {
      // Within a group the fields keep the order of their declaration in the
      // section's *Configuration.ts, not the control-type order the flat
      // panel used to render in.
      const keyOrder = Object.keys(this.selectedSection.configuration)

      return SECTION_GROUP_ORDER
        .map((group) => ({
          id: group as string,
          titleKey: SECTION_GROUP_TITLES[group],
          configs: this.configuration
            .filter((config: DraftConfiguration) => sectionSettingGroupForKey(config.key) === group)
            .filter((config: DraftConfiguration) => matchesSettingFilter(this.$trans(config.trans), this.settingsFilter))
            .sort((a: DraftConfiguration, b: DraftConfiguration) => keyOrder.indexOf(a.key) - keyOrder.indexOf(b.key))
        }))
        .filter((group) => group.configs.length > 0)
    },
    groupIds (): Array<string> {
      return this.groupedConfiguration.map((group: { id: string }) => `section:${group.id}`)
    },
    showSettingsFilter (): boolean {
      return this.configuration.length >= MIN_SETTINGS_FOR_FILTER
    },
    hasSoleGroup (): boolean {
      return this.groupedConfiguration.length === 1
    },
    // Images live outside the groups, so the search has to reach them by their
    // own label; otherwise typing "image" answers "nothing found" next to an
    // image picker.
    showImagePickers (): boolean {
      return matchesSettingFilter(this.$trans('wb_image'), this.settingsFilter)
    },
    showPortfolioGallery (): boolean {
      return matchesSettingFilter(this.$trans('home_about_element_gallery'), this.settingsFilter)
    }
  },
  methods: {
    ...mapActions({
      openDialog: 'dialog/open',
      updateImage: 'builder/updateImage',
      removeImage: 'builder/removeImage',
      setExternalConfiguration: 'builder/setExternalConfiguration'
    }),
    isTextFieldNumberDisabledForConfig (config: DraftConfiguration) {
      return (config.key === 'wb_gallery_width__number__' && this.isMobile)
    },
    configByKey (key: string): DraftConfiguration | undefined {
      return this.configuration.find((config: DraftConfiguration) => config.key === key)
    },
    onCheckboxChange (config: DraftConfiguration) {
      this.updateConfigurationProperty(config.key, config.value, true)

      if (config.value && REQUIRE_TO_SHOW[config.key]) {
        const showConfig = this.configByKey(REQUIRE_TO_SHOW[config.key])
        if (showConfig && !showConfig.value) {
          showConfig.value = true
          this.updateConfigurationProperty(showConfig.key, true, true)
        }
      }

      if (!config.value) {
        const requireKey = Object.keys(REQUIRE_TO_SHOW).find((key) => REQUIRE_TO_SHOW[key] === config.key)
        if (requireKey) {
          const requireConfig = this.configByKey(requireKey)
          if (requireConfig && requireConfig.value) {
            requireConfig.value = false
            this.updateConfigurationProperty(requireKey, false, true)
          }
        }
      }
    },
    dateMinFor (config: DraftConfiguration): string {
      const pair = DATE_RANGE_PAIRS.find((pair) => pair.to === config.key)
      const fromConfig = pair ? this.configByKey(pair.from) : undefined
      return (fromConfig && fromConfig.value) ? String(fromConfig.value) : ''
    },
    dateMaxFor (config: DraftConfiguration): string {
      const pair = DATE_RANGE_PAIRS.find((pair) => pair.from === config.key)
      const toConfig = pair ? this.configByKey(pair.to) : undefined
      return (toConfig && toConfig.value) ? String(toConfig.value) : ''
    },
    resetOpenPanels () {
      // Every group starts collapsed, so a section opens as a short list of
      // group names that fits the 360px drawer without scrolling. Groups the
      // user has opened or collapsed before keep that state.
      //
      // A section whose settings all land in one group renders that group
      // without a header (there is nothing to collapse against), so leaving
      // it closed would show an empty panel.
      this.openPanels = panelsToOpen(this.groupIds, { filtering: !!this.settingsFilter })
    },
    singleImageChangeHandle (selectedGalleryImage: SelectedGalleryImage, sectionImage: SectionImage): void {
      sectionImage.name = selectedGalleryImage.defaultImage.name

      this.updateImage({
        selectedGalleryImage,
        sectionImage
      } as SectionImagePayload)
    },
    internalImageChangeHandle (selectedGalleryImage: SelectedGalleryImage | null, sectionImage: SectionImage): void {
      if (selectedGalleryImage) {
        this.updateImage({
          selectedGalleryImage,
          sectionImage
        } as SectionImagePayload)
      } else {
        this.removeImage(sectionImage)
      }
    },
    createPortfolioImageHandle (selectedGalleryImage: SelectedGalleryImage, sectionImage: SectionImage): void {
      this.updateImage({
        selectedGalleryImage,
        sectionImage
      } as SectionImagePayload)
    },
    openSidebarDetailsExternalConfigurationHandle (id: number) {
      this.setExternalConfiguration(id)
      this.openSidebarDetails(new SidebarDetails(true, SidebarDetailsType.EXTERNAL_CONFIGURATION, {}))
    },
    openPagesSidebarDetails (key: string): void {
      this.openSidebarDetails(new SidebarDetails(true, SidebarDetailsType.PAGES_SELECT, { key }))
    },
    updateConfigurationForData <T> (data: Array<T>, key: string): void {
      this.updateConfigurationProperty(key, classToPlain(data), true)
    },
    generateArrayCtaButtonsData (value: object): Array<CtaButtonData> {
      return plainToClass(CtaButtonData, value as Array<CtaButtonData>)
    },
    generateArrayDynamicFormElementsData (value: object): Array<DynamicFormData> {
      return plainToClass(DynamicFormData, value as Array<DynamicFormData>)
    },
    generateArrayGdprFieldElementsData (value: object): Array<GdprFieldData> {
      return plainToClass(GdprFieldData, value as Array<GdprFieldData>)
    },
    generateArraySectionFeaturesData (value: object): Array<SectionsFeatureData> {
      return plainToClass(SectionsFeatureData, value as Array<SectionsFeatureData>)
    },
    getCtaButtonClassObject (value: object): CtaButtonData {
      return plainToClass(CtaButtonData, value)
    },
    getItemsForSelectType (type: BuilderSelectType): Array<Record<string, any>> {
      switch (type) {
        case BuilderSelectType.BUTTONS_POSITIONS:
          return DefaultButtonsPositions()
        case BuilderSelectType.FORM_POSITIONS:
          return DefaultFormPositions()
        case BuilderSelectType.IMAGE_POSITIONS:
          return DefaultImagePositions()
        case BuilderSelectType.IMAGE_ROUNDED:
        case BuilderSelectType.VIEW_ROUNDED:
          return DefaultRoundTypes()
        case BuilderSelectType.GALLERY_STYLE:
          return DefaultGalleryStyles()
        case BuilderSelectType.BUTTON_SIZE:
          return DefaultButtonSizeTypes()
        case BuilderSelectType.SELECTION_ORDER:
          return DefaultSelectionOrders()
      }

      return []
    },
    getTitleForSelectType (type: BuilderSelectType): string | null {
      switch (type) {
        case BuilderSelectType.BUTTONS_POSITIONS:
          return this.$trans('wb_buttons_position_title')
        case BuilderSelectType.FORM_POSITIONS:
          return this.$trans('wb_form_position_title')
        case BuilderSelectType.IMAGE_POSITIONS:
          return this.$trans('wb_image_position_title')
        case BuilderSelectType.IMAGE_ROUNDED:
          return this.$trans('wb_image_rounded')
        case BuilderSelectType.VIEW_ROUNDED:
          return this.$trans('wb_view_rounded')
        case BuilderSelectType.GALLERY_STYLE:
          return this.$trans('wb_gallery_style')
        case BuilderSelectType.BUTTON_SIZE:
          return this.$trans('wb_button_size_title')
        case BuilderSelectType.SELECTION_ORDER:
          return this.$trans('wb_selection_order')
      }

      return null
    },
    getObjectForSelectTypeAndValue (type: BuilderSelectType, value: AlignType | RoundType | GalleryStyleType | ButtonSizeType | string): Record<string, any> | string | null {
      switch (type) {
        case BuilderSelectType.BUTTONS_POSITIONS:
        case BuilderSelectType.IMAGE_POSITIONS:
        case BuilderSelectType.FORM_POSITIONS:
          return {
            text: this.getTextForAlignType(value as AlignType),
            value
          }
        case BuilderSelectType.IMAGE_ROUNDED:
        case BuilderSelectType.VIEW_ROUNDED:
          return {
            text: this.getTextForRoundType(value as RoundType),
            value
          }
        case BuilderSelectType.GALLERY_STYLE:
          return {
            text: this.getTextForGalleryStyleType(value as GalleryStyleType),
            value
          }
        case BuilderSelectType.BUTTON_SIZE:
          return {
            text: this.getTextForButtonSizeType(value as ButtonSizeType),
            value
          }
        case BuilderSelectType.SELECTION_ORDER:
          return {
            text: this.$trans(`wb_selection_order_${value as SelectionOrderType}`),
            value
          }
        case BuilderSelectType.PAGE_ID: {
          const page = this.draftPagesWithStaticPages.find((page: Page | StaticPage) => page.uuid === value)
          if (page) {
            return page.uuid
          }

          return null
        }
      }

      return null
    },
    getTextForAlignType (type: AlignType): string {
      switch (type) {
        case AlignType.TOP_LEFT:
          return this.$trans('wb_position_top_left_title')
        case AlignType.TOP_RIGHT:
          return this.$trans('wb_position_top_right_title')
        case AlignType.TOP_CENTER:
          return this.$trans('wb_position_top_center_title')
        case AlignType.BOTTOM_LEFT:
          return this.$trans('wb_position_bottom_left_title')
        case AlignType.BOTTOM_RIGHT:
          return this.$trans('wb_position_bottom_right_title')
        case AlignType.BOTTOM_CENTER:
          return this.$trans('wb_position_bottom_center_title')
      }
    },
    getTextForRoundType (type: RoundType): string {
      switch (type) {
        case RoundType.ZERO:
          return this.$trans('wb_round_zero_title')
        case RoundType.SM:
          return this.$trans('wb_round_sm_title')
        case RoundType.MD:
          return this.$trans('wb_round_md_title')
        case RoundType.LG:
          return this.$trans('wb_round_lg_title')
        case RoundType.XL:
          return this.$trans('wb_round_xl_title')
        case RoundType.PILL:
          return this.$trans('wb_round_pill_title')
        case RoundType.CIRCLE:
          return this.$trans('wb_round_circle_title')
      }
    },
    getTextForGalleryStyleType (type: GalleryStyleType): string {
      switch (type) {
        case GalleryStyleType.STYLE_1:
          return this.$trans('wb_gallery_style_1_title')
        case GalleryStyleType.STYLE_2:
          return this.$trans('wb_gallery_style_2_title')
        case GalleryStyleType.STYLE_3:
          return this.$trans('wb_gallery_style_3_title')
      }
    },
    getTextForButtonSizeType (type: ButtonSizeType): string {
      switch (type) {
        case ButtonSizeType.X_SMALL:
          return this.$trans('wb_button_size_type_x_small_title')
        case ButtonSizeType.SMALL:
          return this.$trans('wb_button_size_type_small_title')
        case ButtonSizeType.MEDIUM:
          return this.$trans('wb_button_size_type_medium_title')
        case ButtonSizeType.LARGE:
          return this.$trans('wb_button_size_type_large_title')
        case ButtonSizeType.X_LARGE:
          return this.$trans('wb_button_size_type_x_large_title')
      }
    },
    getDynamicFormTypeForKey (key: string): string {
      if (key === 'wb_booking_dynamic_form__dynamic_form__') {
        return DynamicFormType.BOOKING
      }

      return DynamicFormType.GENERAL
    }
  }
})
